import moment from "moment";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import docRevsFunctions from "@/document/revisions/mixins/docRevsFunctions.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import { mapGetters } from "vuex";

export default {
  // eslint-disable-next-line
  mixins: [
    generateForms,
    generateID,
    docRevsFunctions,
    relationshipsFunctions,
    transFunctions
  ],
  computed: {
    ...mapGetters([
      "getUser",
      "getCompanyDID",
      "getCurrentPage",
      "getPreviousPage"
    ])
  },
  methods: {
    facilityTag(tag) {
      let page = this.getCurrentPage;
      let prev = this.getPreviousPage;
      let logic = null;
      // console.log(tag);
      // console.log(page);
      if (
        tag === "A1" ||
        tag === "A.F1" ||
        tag === "E8" ||
        tag === "E8.A1" ||
        tag === "M5" ||
        tag === "M7" ||
        tag === "O1" ||
        tag === "W1" ||
        tag === "W2"
      ) {
        logic = true;
      } else if (page === "/assetdetail" && tag === "E2") {
        logic = true;
      } else if (page === "/facilitydash" && tag === "F1") {
        logic = true;
      } else if (page === "/facilitydash" && tag === "E2") {
        logic = true;
      } else if (page === "/facilitydash" && tag === "G1") {
        logic = true;
      } else if (page === "/maintplandetail" && tag === "B3") {
        logic = true;
      } else if (
        page === "/facilitydashviewvendor" &&
        (tag === "F1" || tag === "S1")
      ) {
        logic = true;
      } else if (
        page === "/facilitydashviewcontractor" &&
        (tag === "F1" || tag === "S1")
      ) {
        logic = true;
      } else if (
        page === "/facilitydashviewintegrated" &&
        (tag === "F1" || tag === "S1" || tag === "S6")
      ) {
        logic = true;
      } else if (page === "/facilitydashoperations") {
        logic = true;
        if (tag === "B1" || tag === "B3" || tag === "S1" || tag === "S6") {
          logic = true;
        } else {
          logic = false;
        }
      } else if (page === "/facilitydashmaintenance") {
        if (tag === "B6" || tag === "W6") {
          logic = true;
        } else {
          logic = false;
        }
      } else if (page === "/facilitydashengineering") {
        if (tag === "E2" || tag === "E6" || tag === "E8") {
          logic = true;
        } else {
          logic = false;
        }
      } else if (page === "/registerlist") {
        if (prev === "/facilitydashoperations") {
          if (tag === "B1" || tag === "B3" || tag === "S1" || tag === "S6") {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/facilitydashmaintenance") {
          if (tag === "B6" || tag === "W6") {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/facilitydashengineering") {
          if (tag === "E2" || tag === "E2") {
            logic = true;
          } else {
            logic = false;
          }
        } else {
          logic = false;
        }
      } else if (page === "/accesslist") {
        if (prev === "/facilitydash" && tag === "G1") {
          logic = true;
        } else {
          logic = false;
        }
      } else if (prev === "/registerlist") {
        if (page === "/incidentdetail" && tag === "B3") {
          logic = true;
        } else if (page === "/engineeringdetail" && tag === "B3") {
          logic = true;
        } else if (page === "/workrequestdetail" && tag === "B3") {
          logic = true;
        } else if (page === "/workcalldetail" && tag === "B3") {
          logic = true;
        } else if (page === "/riskdetail" && tag === "B3") {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    companyTag(tag) {
      let logic = null;
      let page = this.getCurrentPage;
      let prev = this.getPreviousPage;
      if (
        tag === "A.C1" ||
        tag === "S1" ||
        tag === "S6" ||
        tag === "B1" ||
        tag === "B4" ||
        tag === "B6" ||
        tag === "C1" ||
        tag === "E1" ||
        tag === "E6" ||
        tag === "L1" ||
        tag === "M2" ||
        tag === "Q1"
      ) {
        logic = true;
      } else if (page === "/userdash" && tag === "F1") {
        // SEARCH FOR FACILITY ACCESS
        logic = true;
      } else if (page === "/companymanagement" && tag === "B3") {
        // SEARCH FOR FACILITY ACCESS
        logic = true;
      } else if (page === "/companydash" && tag === "G1") {
        logic = true;
      } else if (page === "/companydash" && tag === "F1") {
        logic = true;
      } else if (page === "/accesslist") {
        if (prev === "/companydash" && tag === "G1") {
          logic = true;
        } else {
          logic = false;
        }
      } else if (page === "/registerlist" && tag === "B3") {
        logic = true;
      } else if (page === "/registerlist" && tag === "E2") {
        logic = true;
      } else if (
        page === "/companydashbusiness" &&
        (tag === "B1" || tag === "B3" || tag === "B6")
      ) {
        logic = true;
      } else if (
        page === "/companydashengineering" &&
        (tag === "E1" || tag === "E2" || tag === "E6")
      ) {
        logic = true;
      } else if (
        page === "/companydashmaintenance" &&
        (tag === "E6" || tag === "L1" || tag === "W6")
      ) {
        logic = true;
      } else if (
        page === "/companydashviewoperator" &&
        (tag === "B1" ||
          tag === "E6" ||
          tag === "L1" ||
          tag === "S1" ||
          tag === "S6" ||
          tag === "W6")
      ) {
        logic = true;
      } else if (
        page === "/companydashsafety" &&
        (tag === "B1" ||
          tag === "E6" ||
          tag === "L1" ||
          tag === "S1" ||
          tag === "S6" ||
          tag === "W6")
      ) {
        logic = true;
      } else if (
        page === "/companydashtechnical" &&
        (tag === "E2" || tag === "E6" || tag === "W6")
      ) {
        logic = true;
      } else if (page === "/companydashviewexternal" && tag === "S1") {
        logic = true;
      } else if (page === "/registerlist") {
        if (prev === "/companydashviewoperator") {
          if (
            tag === "B1" ||
            tag === "E6" ||
            tag === "L1" ||
            tag === "S1" ||
            tag === "S6" ||
            tag === "W6"
          ) {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/companydash") {
          if (tag === "F1") {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/companydashmaintenance") {
          if (tag === "E6" || tag === "L1" || tag === "W6") {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/companydashtechnical") {
          if (tag === "E2" || tag === "E6" || tag === "W6") {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/companydashbusiness") {
          if (tag === "B3" || tag === "B4" || tag === "B6") {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/companydashsafety") {
          if (tag === "B1" || tag === "S1" || tag === "S6") {
            logic = true;
          } else {
            logic = false;
          }
        } else if (prev === "/companydashengineering") {
          if (tag === "E1" || tag === "E2") {
            logic = true;
          } else {
            logic = false;
          }
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    enableAccessAuthAll(tag) {
      let logic = null;
      let auth = this.defineAccessAuthNew(tag);
      let user = null;
      // CHECK AUTH
      if (this.companyTag(tag)) {
        auth = this.defineAccessAuthCompanyCreate(tag);
        user = this.getUser.pref.select.cauth;
      } else if (this.facilityTag(tag)) {
        auth = this.defineAccessAuthFacilityCreate(tag);
        user = this.getUser.pref.select.fauth;
      } else {
        // do nothing
      }
      // CHEKC LOGIC
      if (user < auth || auth === user) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableAccessAuthCreate(tag) {
      let logic = null;
      let auth = null;
      let user = null;
      // CHECK AUTH
      if (this.companyTag(tag)) {
        auth = this.defineAccessAuthCompanyCreate(tag);
        user = this.getUser.pref.select.cauth;
      } else if (this.facilityTag(tag)) {
        auth = this.defineAccessAuthFacilityCreate(tag);
        user = this.getUser.pref.select.fauth;
      } else {
        auth = 1;
        user = 10;
      }
      // console.log("");
      // console.log("CREATE ACCESS");
      // console.log(tag);
      // console.log("USER ACCESS " + user);
      // console.log("AUTH ACCESS " + auth);
      // console.log("FTAG " + this.facilityTag(tag));
      // console.log("CTAG " + this.companyTag(tag));
      // CHECK LOGIC
      if (user < auth || auth === user) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableAccessAuthEdit(tag) {
      let logic = null;
      let auth = null;
      let user = null;
      // CHECK TAG
      if (this.companyTag(tag)) {
        auth = this.defineAccessAuthCompanyEdit(tag);
        user = this.getUser.pref.select.cauth;
      } else if (this.facilityTag(tag)) {
        auth = this.defineAccessAuthFacilityEdit(tag);
        user = this.getUser.pref.select.fauth;
      } else {
        auth = 1;
        user = 10;
      }
      // EDIT
      // console.log("");
      // console.log("EDIT Functions: " + tag);
      // console.log("USER ACCESS : " + user);
      // console.log("AUTH ACCESS : " + auth);
      // console.log("FTAG " + this.facilityTag(tag));
      // console.log("CTAG " + this.companyTag(tag));
      // CHECK AUTH
      if (this.getUser.basic.admin === true) {
        logic = true;
      } else if (user < auth || auth === user) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableAccessAuthDash(tag) {
      let logic = null;
      let auth = null;
      let user = null;
      // CHECK TAG
      if (tag === "C1") {
        auth = this.defineAccessAuthCompanyDash(tag);
        user = this.getUser.pref.select.cauth;
      } else if (tag === "F1") {
        auth = this.defineAccessAuthFacilityDash(tag);
        user = this.getUser.pref.select.fauth;
      } else {
        auth = 1;
        user = 10;
      }
      // CHECK AUTH
      if (user < auth || auth === user) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableAccessAuthView(tag) {
      let logic = null;
      let auth = null;
      let user = null;
      // CHECK TAG
      if (this.companyTag(tag)) {
        auth = this.defineAccessAuthCompanyView(tag);
        user = this.getUser.pref.select.cauth;
      } else if (this.facilityTag(tag)) {
        auth = this.defineAccessAuthFacilityView(tag);
        user = this.getUser.pref.select.fauth;
      } else {
        auth = 1;
        user = 10;
      }
      // CHECK AUTH
      if (user < auth || auth === user) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableAccessAuthUpdate(tag) {
      let logic = null;
      let auth = null;
      let user = null;
      // CHECK TAG
      if (this.companyTag(tag)) {
        auth = this.defineAccessAuthCompanyUpdate(tag);
        user = this.getUser.pref.select.cauth;
      } else if (this.facilityTag(tag)) {
        auth = this.defineAccessAuthFacilityUpdate(tag);
        user = this.getUser.pref.select.fauth;
      } else {
        auth = 1;
        user = 10;
      }
      // CHECK AUTH
      if (user < auth || auth === user) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableAccessAuthSearch(tag) {
      let logic = null;
      let auth = null;
      let user = null;
      // CHECK TAG
      if (this.companyTag(tag)) {
        auth = this.defineAccessAuthCompanySearch(tag);
        user = this.getUser.pref.select.cauth;
      } else if (this.facilityTag(tag)) {
        auth = this.defineAccessAuthFacilitySearch(tag);
        user = this.getUser.pref.select.fauth;
      } else {
        auth = 1;
        user = 10;
      }
      // SEARCH
      // console.log("");
      // console.log("SEARCH ACCESS   " + tag);
      // console.log("USER ACCESS : " + user);
      // console.log("AUTH ACCESS : " + auth);
      // console.log("FTAG " + this.facilityTag(tag));
      // console.log("CTAG " + this.companyTag(tag));
      // CHECK AUTH
      if (user < auth || auth === user) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    defineAccessAuthCompanyAll(tag) {
      let auth = null;
      if (tag !== "F1" && tag !== "G1") {
        auth = 1;
      } else if (
        tag === "B1" ||
        tag === "B3" ||
        tag === "B6" ||
        tag === "E1" ||
        tag === "E2" ||
        tag === "E6" ||
        tag === "M2"
      ) {
        auth = 2;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthCompanyDash(tag) {
      let auth = null;
      if (tag === "C1" || tag === "F1") {
        auth = 3;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthCompanyCreate(tag) {
      let auth = null;
      if (tag === "F1") {
        auth = 1;
      } else if (tag === "S1" || tag === "B4") {
        auth = 3;
      } else if (tag === "B6") {
        auth = 4;
      } else if (
        tag === "B1" ||
        tag === "E1" ||
        tag === "E2" ||
        tag === "E6" ||
        tag === "L1" ||
        tag === "M2" ||
        tag === "S6"
      ) {
        auth = 5;
      } else if (tag === "Q1" || tag === "W6") {
        auth = 6;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthCompanyEdit(tag) {
      let auth = null;
      if (tag === "G1") {
        auth = 0;
      } else if (tag === "C1" || tag === "F1") {
        auth = 1;
      } else if (tag === "B4") {
        auth = 2;
      } else if (tag === "Q1" || tag === "S1") {
        auth = 3;
      } else if (tag === "B1" || tag === "B6" || tag === "E1" || tag === "M2") {
        auth = 4;
      } else if (
        tag === "E2" ||
        tag === "E6" ||
        tag === "S6" ||
        tag === "A.C1"
      ) {
        auth = 5;
      } else if (tag === "L1" || tag === "W6") {
        auth = 6;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthCompanySearch(tag) {
      let auth = null;
      if (this.getCurrentPage === "/userdash" && tag === "F1") {
        auth = 10;
      } else if (tag === "G1") {
        auth = 3;
      } else if (tag === "B3" || tag === "B4" || tag === "A.C1") {
        auth = 5;
      } else if (tag === "B6" || tag === "F1" || tag === "M2" || tag === "S6") {
        auth = 6;
      } else if (
        tag === "B1" ||
        tag === "E1" ||
        tag === "E6" ||
        tag === "G1" ||
        tag === "L1"
      ) {
        auth = 7;
      } else if (tag === "E2" || tag === "W6") {
        auth = 8;
      } else if (tag === "S1") {
        auth = 9;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthCompanyUpdate(tag) {
      let auth = null;
      if (tag === "S6") {
        auth = 7;
      }
      return auth;
    },
    defineAccessAuthCompanyView(tag) {
      let auth = null;
      if (tag === "C1") {
        auth = 8;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthFacilityAll(tag) {
      let auth = null;
      if (tag === "F1" || tag === "M5" || tag === "S6") {
        auth = 1;
      } else if (
        tag === "M7" ||
        tag === "S1" ||
        tag === "W1" ||
        tag === "W2" ||
        tag === "W3"
      ) {
        auth = 2;
      } else if (tag === "A1" || tag === "E2" || tag === "E8") {
        auth = 3;
      } else if (tag === "O1") {
        auth = 5;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthFacilityDash(tag) {
      let auth = null;
      if (tag === "F1") {
        auth = 3;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthFacilityCreate(tag) {
      let auth = 0;
      if (tag === "B6" || tag === "S1") {
        auth = 2;
      } else if (
        tag === "A1" ||
        tag === "B1" ||
        tag === "B3" ||
        tag === "M5" ||
        tag === "F1"
      ) {
        auth = 3;
      } else if (tag === "E2" || tag === "W6") {
        auth = 4;
      } else if (tag === "S6" || tag === "W1" || tag === "E8") {
        auth = 6;
      } else if (tag === "O1") {
        auth = 8;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthFacilityEdit(tag) {
      let auth = null;
      if (tag === "G1") {
        auth = 1;
      } else if (tag === "F1") {
        auth = 1;
      } else if (tag === "M5") {
        auth = 2;
      } else if (tag === "B1" || tag === "B6" || tag === "S1") {
        auth = 3;
      } else if (
        tag === "A1" ||
        tag === "E2" ||
        tag === "E8" ||
        tag === "W1" ||
        tag === "W2" ||
        tag === "W6"
      ) {
        auth = 4;
      } else if (
        tag === "B3" ||
        tag === "S6" ||
        tag === "O1" ||
        tag === "A.F1"
      ) {
        auth = 5;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthFacilitySearch(tag) {
      let auth = null;
      if (tag === "G1") {
        auth = 0;
      } else if (tag === "F1") {
        auth = 4;
      } else if (tag === "B3") {
        auth = 3;
      } else if (
        tag === "B1" ||
        tag === "E8" ||
        tag === "S6" ||
        tag === "W1" ||
        tag === "W2" ||
        tag === "A.F1"
      ) {
        auth = 5;
      } else if (tag === "A1") {
        auth = 6;
      } else if (tag === "O1") {
        auth = 7;
      } else if (tag === "S1") {
        auth = 8;
      } else {
        auth = 10;
      }
      return auth;
    },
    defineAccessAuthFacilityUpdate(tag) {
      let auth = null;
      if (tag === "E8" || tag === "W1" || tag === "W2" || tag === "W3") {
        auth = 9;
      }
      return auth;
    },
    defineAccessAuthFacilityView(tag) {
      let auth = null;
      if (tag === "F1") {
        auth = 8;
      } else {
        auth = 10;
      }
      return auth;
    },
    generateAccess(doc, tagd, tags, did) {
      // doc is access
      // SET data source
      let tag = "G1";
      let dbs = "";

      // DEFINE DID
      // const DID = did; // same as original id;
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateAccessForm(); // generuc form

      // BASIC
      temp.basic.act = true;
      temp.basic.did = did; // generated externally as common
      temp.basic.idg = idg;
      temp.basic.tag = tag; // this is access and it is "G1"
      temp.basic.tags = tags; // where it orginated from
      temp.basic.tagd = tagd; // destination where it belongs;
      temp.basic.dbs = dbs;
      temp.basic.title = doc.basic.title;

      // CHAR
      temp.char.udid = this.getUser.basic.did;
      temp.char.uidg = this.getUser.basic.idg;
      temp.char.uemail = this.getUser.basic.email;
      temp.char.utitle = this.getUser.basic.title;
      temp.char.tag = doc.basic.tag;
      temp.char.title = doc.basic.title;
      temp.char.did = doc.basic.did;
      temp.char.id = doc.basic.id;
      temp.char.idg = doc.basic.idg;

      // STATS
      temp.stats.dcrt = moment().format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // TRANS
      let trans = this.generateInitalTransition(tag); // model
      // let trans = this.generateInitalTrans("Y"); // model f
      temp.trans = trans;

      // RELPS
      let relps = this.generateInitialRelationships(tag);
      temp.relps = relps;

      // SELECT
      // eslint-disable-next-line
      // new company user access
      if (tagd === "C1" || tagd === "Z5") {
        temp.select.ctag = doc.basic.tag; // company tag
        temp.select.cname = doc.basic.title; // company legal name
        temp.select.cshort = ""; // short name
        temp.select.cdid = doc.basic.did;
        temp.select.cidg = doc.basic.idg;
        temp.select.cid = doc.basic.id;
        // temp.select.caccess= doc.pref.access;
        if (tagd === "Z5") {
          temp.select.cauth = 0; // New company Admin Level
        } else {
          temp.select.cauth = null; // New company Admin Level
        }
        // new facility user
      } else if (tagd === "F1") {
        temp.select.cdid = this.getCompanyDID; // company tag
        temp.select.fauth = null; // New company Admin Level
        temp.select.ftag = doc.basic.tag; // company tag
        temp.select.fname = doc.basic.title; // company legal name
        temp.select.fshort = ""; // short name
        temp.select.fdid = doc.basic.did;
        temp.select.fidg = doc.basic.idg;
        temp.select.fid = doc.basic.id;
        // temp.select.faccess= doc.pref.access;
      } else {
        // this is user access
        if (tags === "NEW C1") {
          temp.basic.tags = "C1";
          temp.select.ctag = doc.basic.tag; // company tag
          temp.select.cname = doc.basic.title; // company legal name
          temp.select.cshort = ""; // short name
          temp.select.cdid = doc.basic.did;
          temp.select.cidg = doc.basic.idg;
          temp.select.cid = doc.basic.id;
          temp.select.cauth = 0; // New company Admin Level
          // temp.select.caccess= doc.pref.access;
        }
        if (tags === "C1") {
          temp.select.ctag = doc.basic.tag; // company tag
          temp.select.cname = doc.basic.title; // company legal name
          temp.select.cshort = ""; // short name
          temp.select.cdid = doc.basic.did;
          temp.select.cidg = doc.basic.idg;
          temp.select.cid = doc.basic.id;
          // temp.select.caccess= doc.pref.access;
        }
        if (tags === "NEW F1") {
          temp.basic.tags = "F1";
          temp.select = this.getUser.pref.select;
          temp.select.ftag = doc.basic.tag; // company tag
          temp.select.fname = doc.basic.title; // company legal name
          temp.select.fshort = ""; // short name
          temp.select.fdid = doc.basic.did;
          temp.select.fidg = doc.basic.idg;
          temp.select.fid = doc.basic.id;
          temp.select.fauth = 0; // New company Admin Level
          // temp.select.faccess = doc.pref.access;
        }
        if (tags === "F1") {
          temp.select.cdid = this.getCompanyDID; // company tag
          temp.select.ftag = doc.basic.tag; // company tag
          temp.select.fname = doc.basic.title; // company legal name
          temp.select.fshort = ""; // short name
          temp.select.fdid = doc.basic.did;
          temp.select.fidg = doc.basic.idg;
          temp.select.fid = doc.basic.id;
          // temp.select.faccess = doc.pref.access;
        }
      }
      // GENERATE RELPS LINK
      let link = this.formRelationshipLink;
      link.idg = doc.basic.idg;

      // link.dbs = doc.basic.dbs;
      link.did = doc.basic.did;
      link.title = doc.basic.title;
      link.tag = doc.basic.tag;
      link.rank = "S";
      link.sync = false;
      if (doc.basic.tag === "C1") {
        link.id = doc.char.abn;
      }
      temp.relps.link.push(link);

      // HELP
      // console.log("ACCESS");
      // console.log(temp);

      return temp;
    }
  }
};
